/**
 * The client version is the version displayed to the user on the login screen.
 */
export const getClientVersion = () =>
    window.sparxWebVersions ? window.sparxWebVersions.client_version : '?.??.?';

/**
 * The API V1 version is the version sent to the server on login.
 * It's set to 'dev' when in a development build.
 */
export const getApiV1Version = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'dev';
    } else {
        return window.sparxWebVersions ? window.sparxWebVersions.client_version : '?.??.?';
    }
};
